module.exports = __webpack_public_path__ + "media/src/images/icons/arrow-63461ed38c70826c09ddac1db0cda40b.svg";